// 時刻は「深夜0時からの秒数」で保持される (例: 61200 = 17:00)。
// hour >= 24 は日跨ぎ営業を表す (例: 93600 = 26時 → 翌2時)。
const addPreZero = (num: number): string => {
  return ("00" + num).slice(-2);
};

export interface AmPmLabels {
  am: string;
  pm: string;
  position: "prefix" | "suffix";
}

export const formatTime24h = (
  value: number | null | undefined,
  emptyValue: string = ""
): string => {
  if (!value) {
    return emptyValue;
  }
  const hour = Math.floor(value / 3600);
  return (
    addPreZero(hour >= 24 ? hour - 24 : hour) +
    ":" +
    addPreZero(Math.floor((value % 3600) / 60))
  );
};

export const formatTime12h = (
  value: number | null | undefined,
  labels: AmPmLabels,
  emptyValue: string = ""
): string => {
  if (!value) {
    return emptyValue;
  }
  const hour = Math.floor(value / 3600);
  const minute = addPreZero(Math.floor((value % 3600) / 60));
  const isAm = hour < 12 || hour >= 24;
  const displayHour = isAm
    ? addPreZero(hour >= 24 ? hour - 24 : hour)
    : addPreZero(hour > 12 ? hour - 12 : 12);
  const label = isAm ? labels.am : labels.pm;
  const body = displayHour + ":" + minute;
  return labels.position === "prefix" ? label + body : body + label;
};
